<!-- Loading bar -->
<spri-loading-bar />

<!-- Content -->
<router-outlet />
